import { Authorization } from "../redux_store/slices/authSlice";
import { LOGIN_USER } from "./ApiConstants";
import api from "./ApiHandler";

export const getUserLogin = async (authPayload: Authorization) => {
	return await api.post(LOGIN_USER, authPayload);
};

const AuthServices = { getUserLogin };

export default AuthServices;
